import { LazyRelayModuleWrapper } from '@ms/yammer-relay/dist/environment';
import type { FC } from 'react';
import React, { Suspense } from 'react';

import { GlobalCopilotFloatieButton } from '../components/GlobalCopilot';

export const GlobalCopilotFloatieButtonIntegration: FC = () => (
  <Suspense fallback={null}>
    <LazyRelayModuleWrapper>
      <GlobalCopilotFloatieButton />
    </LazyRelayModuleWrapper>
  </Suspense>
);
